import {ActionHandler} from "../../../infrastructure/handlers/action-handler";
import {NEWS} from "../news-widget.consts";
import {NewsWidgetState} from "../models/news-widget.state";
import {NewsWidgetController} from "../news-widget.controller";
import {AnalyticsEventHandler} from "../../../infrastructure/handlers/analytics-event-handler";
import {AnalyticsService} from "../../../third-party-services/analytics/analytics-service";
import {NewsWidgetArticleClickEvent} from "../models/news-widget.article-click.event";


export class NewsWidgetArticleClickHandler extends AnalyticsEventHandler {
  controller: NewsWidgetController;
  state: NewsWidgetState;
  type = NEWS.ACTION_TYPES.onArticleClick;

  static injectables = [...ActionHandler.injectables, AnalyticsService];

  async action(params) {
    const fullParams = {
      countryId: this.state.appState.locale.userCountryId,
      langId: this.state.appState.locale.language.id,
      sportTypeId: this.state.appState.context.sportType?.id,
      ...params
    }

    const clickEvent: NewsWidgetArticleClickEvent = new NewsWidgetArticleClickEvent(fullParams);

    await this.analyticsService.createEvent(clickEvent);
  }
}